import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, Avatar, Typography, Divider, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { FaStar, FaMapMarkerAlt, FaRegClock } from 'react-icons/fa';
import { getOrderState } from '../../../store/orders/selector';
import { getUserState } from '../../../store/user/selector';
import { getMealState } from '../../../store/meals/selector';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { arriveTimeDifference } from '../../orders/components/CurrentOrders';
import {
  getScheduleTime,
  calcCrow,
} from '../../dashboard/components/DesktopMealCarousel';
import { ScheduleProps } from '../../meals/AddMeals';
import { usePosition } from 'use-position';

const COOK = 'cook';
const GUEST = 'guest';

export const MealSummary: React.FC = () => {
  const [meals, setMeals] = useState<any[]>();
  const { orders } = useSelector(getOrderState);
  const myMeals = useSelector(getMealState);
  const { user } = useSelector(getUserState);
  const history: History = useHistory();
  const { t } = useTranslation();
  const isCook = user.accountType === COOK;
  const settings = useMemo(
    () => ({ enableHighAccuracy: true, timeout: 0, maximumAge: Infinity }),
    []
  );
  const watch = true;
  const { latitude, longitude } = usePosition(watch, settings);

  const handlePress = () => {
    if (isCook) {
      history.push('/mymeals');
    }
    if (!isCook) {
      history.push('/orders');
    }
  };

  const handleCardClick = (item: any) => {
    if (isCook) {
      history.push(`/mymeals/${item.id}`);
    }
    if (!isCook) {
      const ArriveTime = arriveTimeDifference(item.consumptiondate);
      const getFirstSchedule: ScheduleProps | undefined = _.head(item.schedule);
      const getFirstScheduleTime = _.head(getFirstSchedule?.time);
      const time = getScheduleTime(getFirstScheduleTime);
      const newmealitems = {
        ...item,
        isOrder: true,
        ArriveTime,
        isCook,
        time,
      };
      history.push({
        pathname: '/orderdetails',
        state: {
          ...newmealitems,
        },
      });
    }
  };

  const displayMeal = () => {
    if (user.accountType === COOK) {
      const limitMeal = _.take(myMeals.meals, 3);
      setMeals(limitMeal);
    }
    if (user.accountType === GUEST) {
      const limitMeal = _.take(orders, 3);
      setMeals(limitMeal);
    }
  };

  useEffect(displayMeal, [user, orders, myMeals]);
  return (
    <Col span={24} className="rating-container">
      <div className="block-title">
        <span>{isCook ? t('MY_OFFERS') : t('MY_ORDERS')}</span>
      </div>
      <Row className="meal-summary-cards-container">
        {meals &&
          meals.map((itm: any, i: number) => {
            return (
              <Col
                key={i}
                span={8}
                className="meal-cards"
                style={{ cursor: 'pointer' }}
                onClick={() => handleCardClick(itm)}
              >
                <div
                  className="meal-image"
                  style={{
                    backgroundImage: `url(${itm.image})`,
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                  }}
                ></div>
                <div className="meal-details">
                  {user.accountType === GUEST && (
                    <React.Fragment>
                      <div className="meal-cooks">
                        <div>
                          <Avatar src={itm.cookDetails?.image} />
                          <Typography.Text>
                            {itm.cookDetails?.firstName}
                          </Typography.Text>
                        </div>
                        <span className="meal-profile-rating">
                          <FaStar
                            color="#F7C82E"
                            size={14}
                            style={{ marginRight: 5 }}
                          />
                          4.9
                        </span>
                      </div>
                      <Divider />
                      <div className="meal-time-locations">
                        <Col>
                          <FaMapMarkerAlt color="#A8A8A8" />
                          {/* <span>{}</span> */}
                          <span>
                            {latitude && longitude
                              ? calcCrow(
                                  itm.cookDetails?.location.lat,
                                  itm.cookDetails?.location.lng,
                                  latitude,
                                  longitude
                                ).toFixed(2) + 'km'
                              : itm.cookDetails?.address.city}
                          </span>
                        </Col>
                        <Col className="float-right">
                          <FaRegClock size={15} color="#939393" />
                          <span>17 PM – 23 PM</span>
                        </Col>
                      </div>
                    </React.Fragment>
                  )}
                  <div className="meal-details-title">
                    <Typography.Text
                      className="meal-details-title"
                      ellipsis
                      style={{ width: 257.5 }}
                    >
                      {itm.title}
                    </Typography.Text>
                    <div className="meal-details-description">
                      {itm.description}
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
      </Row>
      <Row justify="center">
        {_.isEmpty(meals) && (
          <Typography.Text>
            {isCook ? t('NO_OFFER_LISTED') : t('Currently you have no orders')}
          </Typography.Text>
        )}
        <Col span={24} style={{ padding: 20 }}>
          <Col className="primary-button-basic-container header-button">
            <Button
              type="primary"
              shape="round"
              className="primary-button-basic profile-button"
              onClick={handlePress}
              style={{ maxWidth: 'unset' }}
            >
              {isCook ? t('GO_TO_OFFERS') : t('GO_TO_ORDERS')}
            </Button>
          </Col>
        </Col>
      </Row>
    </Col>
  );
};
